export default "__VITE_ASSET__Bxq3yERw__"